import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { useModeTokens } from './useModeTokens';

interface DawTileProps {
  /** Logo URL, typically from `dawLogos`. */
  src?: string;
  /** Accessible name, e.g. "Ableton Live". */
  label: string;
  size?: number;
  radius?: number;
  /** Pin to one mode instead of following the theme. */
  light?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Rounded DAW icon. Backed by a neutral well so a missing or slow logo still
 * holds its place in the layout rather than collapsing the row.
 */
export const DawTile: React.FC<DawTileProps> = ({
  src,
  label,
  size = 36,
  radius = 9,
  light,
  sx,
}) => {
  const t = useModeTokens(light);

  return (
    <Box
      role="img"
      aria-label={label}
      sx={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: `${radius}px`,
        backgroundColor: t.surfaces.iconWell,
        backgroundImage: src ? `url('${src}')` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        ...sx,
      }}
    />
  );
};

export default DawTile;
